// NOTE: all exported methods MUST return the '@context'
import RequestContext from '../../services/RequestContext';
import { useContext } from 'react';
import { useRouter } from 'next/router';
import { replaceParams } from '../../services/content';

/**
 * For SEO purposes, we want the canonical URL to ONLY include canonical URL params. I.e., every VALID filter URL param,
 * except "sort", which does not change the results (only the order). On non-search pages, there is no valid url param.
 * @param {string} urlPath -- Valid URL path. Must not contain non-canonical URL params (e.g., "utm", "coupon", etc.).
 * @returns string
 */
export const makeCanonicalURL = urlPath => {
  const { hostname } = useContext(RequestContext);
  return `https://${hostname}${replaceParams(urlPath, { sort: null })}`;
};

export const getProductLinkingData = (
  title,
  thumbnail,
  description,
  urlPath = useRouter().asPath
) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: title != null ? title.replace(/"/g, '\\"') : '',
    image: thumbnail,
    description: description ? description.replace(/"/g, '\\"') : '',
    url: makeCanonicalURL(urlPath),
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      priceSpecification: {
        '@type': 'UnitPriceSpecification',
        priceCurrency: 'USD',
        priceComponentType: 'https://schema.org/Subscription',
        price: 8.0,
        billingIncrement: 1,
        unitCode: 'MON',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
          unitCode: 'MON',
        },
      },
    },
  };
};

const getSearchPageListItemsLinkingData = results => {
  const items = [];

  for (let i = 0; i < results.length; i++) {
    items.push({
      '@type': 'ListItem',
      position: i + 1,
      Item: getProductLinkingData(
        results[i].title,
        results[i].thumbnail ? results[i].thumbnail.src : '',
        results[i].description,
        results[i].url
      ),
    });
  }

  return items;
};

export const getSearchPageLinkingData = results => {
  return {
    '@context': 'https://schema.org',
    '@type:': 'ItemList',
    ItemListElement: getSearchPageListItemsLinkingData(results),
  };
};
